import { generateStripeState } from '../helper'

const options = {
  api: {
    delete: ({ id }) => `/api/stripe/customer/${id}/discount`,
  },
  actions: {
    delete: 'deleteCustomerDiscount',
  },
}

const {
  actions: stripeActions,
} = generateStripeState(options)

export default {
  actions: {
    ...stripeActions
  }
}
